import React from 'react';
import {
  Squish,
  Flex,
  Stack,
  Copy,
  Image,
} from '@grubhubprod/gh-cookbook-react';

interface IAddEmployeesOptionButton {
  onClick: () => void;
  buttonCopy: string;
  buttonImage: string;
}

export function AddEmployeesOptionButton({
  onClick,
  buttonCopy,
  buttonImage,
}: IAddEmployeesOptionButton): JSX.Element {
  return (
    <button className="addPeopleOptionButton" onClick={onClick}>
      <Squish inset="lg" dimension="1" borderRadius="4px">
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Stack y="x-sm">
            <Image
              width="50px"
              height="50px"
              src={buttonImage}
              alt=""
              role="presentation"
            />
          </Stack>
          <Copy variant="body" color="interactive">
            {buttonCopy}
          </Copy>
        </Flex>
      </Squish>
    </button>
  );
}
